export enum FacturacionEstado {
  Borrador,
  Enviada,
  Pagada,
  Adeudada,
}

export const FacturacionEstadoLabels: { [key in FacturacionEstado]: string } = {
  [FacturacionEstado.Borrador]: 'Borrador',
  [FacturacionEstado.Enviada]: 'Enviada',
  [FacturacionEstado.Pagada]: 'Pagada',
  [FacturacionEstado.Adeudada]: 'Adeudada',
};

export const getFacturacionEstado = () => {
  return Object.values(FacturacionEstado)
    .filter((value) => typeof value === 'number')
    .map((id) => ({
      id,
      text: FacturacionEstadoLabels[id as FacturacionEstado],
    }));
};

export const colorMapping: { [key in FacturacionEstado]: string } = {
  [FacturacionEstado.Borrador]: '#70BDFF',
  [FacturacionEstado.Enviada]: 'orange',
  [FacturacionEstado.Pagada]: '#22c55e',
  [FacturacionEstado.Adeudada]: '#FF0000',
};
